<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeholder"
    clearable
    :filterable="filterable"
    :multiple="multiple"
    @clear="clearHandler"
    @change="changeHandler"
    class="b-i-select"
    :disabled="disabled"
  >
    <el-option
      v-for="item in selectList"
      :key="item[keyName]"
      :label="item[labelName]"
      :value="item[keyName]"
    >
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'SelectItem',
    props: {
      // 默认值
      placeholder: {
        type: String,
        default: '请选择',
      },
      // 下拉框key
      keyName: {
        type: String,
        default: 'id',
      },
      // 下拉框的label
      labelName: {
        type: String,
        default: 'label',
      },
      // 双向数据的值
      value: {
        type: String || Number || Array,
        required: true,
      },
      // 下拉框选项列表
      selectList: {
        type: Array,
        default: () => [],
      },
      // 是否可以搜索
      filterable: {
        type: Boolean,
        default: false,
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectValue: this.value,
      };
    },
    methods: {
      clearHandler() {
        this.$emit('clearHandler');
      },
      changeHandler(value) {
        const currentList = this.selectList.filter((item) => value.includes(item[this.keyName]));
        this.currentSelectList = currentList;
        this.$emit('input', value, currentList);
      },
    },
  };
</script>

<style scoped lang="scss">
  .b-i-select {
    width: 100%;
    ::v-deep {
      .el-select__tags {
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }
</style>
